export const convertUserRoles = (data: any[]) => {
  return data.map((item) => ({
    id: item.id,
    name: item.displayName,
    backendName: item.name,
  }));
};
